import { render, staticRenderFns } from "./loginFormOrg.vue?vue&type=template&id=36409c5f&scoped=true&"
import script from "./loginFormOrg.vue?vue&type=script&lang=js&"
export * from "./loginFormOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36409c5f",
  null
  
)

export default component.exports